import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'

import { getProductTitle, getProductCategory } from '../../services/ColoringProductsHelpers'
import productsText from '../../constants/Cromatica'

import '../../styles/containers/ColoringSubgroups.css'
import Header from '../../components/Header'
import { FiArrowLeft } from 'react-icons/fi'
import { useHistory, useParams } from 'react-router-dom'
import { capitalize } from '../../services/Helpers'
import useLanguage from '../../hooks/useLanguage'

const ColoringSubgroups = props => {
  const history = useHistory()
  const params = useParams()

  const language = useLanguage()

  const subgroups = useMemo(() => {
    const subgroupsList = props.products.subgroupItems
    const groupType = getProductCategory(params.type)
    if (subgroupsList) {
      const selectedSubgroup = subgroupsList.filter((subgroup) => {
        return subgroup.group === groupType
      })
      return selectedSubgroup
    }
    return false
  }, [props.products.subgroupItems])

  useEffect(() => {
    window.scrollTo({
      top: 0
    })
  }, [])

  const renderSubgroups = () => {
    return subgroups.length > 0 ? (
      <div className='coloring-subgroups-items'>
        {subgroups.map(subgroup => {
          const title = getProductTitle(subgroup, language, { forceGetTitle: true })

          return (
            <div onClick={() => history.push(`/cor/maquiagem/categoria/${subgroup.related_id}`)} key={subgroup.id} className='coloring-subgroups-item'>
              <div className='coloring-subgroup-inneritem'>
                <div className='coloring-subgroup-image'>
                  <img style={{
                    objectFit: params.type === 'acessorios' ||
                      params.type === 'maquiagem'
                      ? 'contain' : 'cover'
                  }} src={subgroup.url} alt={title} />
                </div>
                <div className='coloring-subgroup-textbox'>
                  {title}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    ) : (
      <div className='empty-subgroups'>
        <p className='empty-subgroups-text'>
          {productsText.noProducts[language]}
        </p>
      </div>
    )
  }

  return (
    <div className='coloring-subgroups-screen'>
      <Header language={language} />
      <div className='coloring-subgroups-title'>
        <FiArrowLeft onClick={() => history.goBack()}
          size={24} color='var(--primary)' className='coloring-subgroups-goback' />
        <p>{capitalize(params.type)}</p>
      </div>
      {renderSubgroups()}
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.userReducer,
  products: state.productsReducer
})

export default connect(mapStateToProps, actions)(ColoringSubgroups)



// WEBPACK FOOTER //
// ./src/containers/Cromatica/ColoringSubgroups.js